module.exports = __webpack_public_path__ + "img/product1.75e58f13.jpg";